module.exports = __webpack_public_path__ + "static/img/quark--pagecover-image.87aa6e4b.png";